import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Donate from "../pages/Donate";
import Classes from "../pages/Classes";
import JoinUs from "../pages/JoinUs";
import Admin from "../pages/Admin";
import Login from "../pages/admin/Login";
import AdminDashboard from "../pages/admin/AdminDashboard";
import ProtectedRoute from "../components/ProtectedRoute";
import VolunteerDashboard from "../pages/admin/VolunteerDashboard";
import LiveDonationPopup from "../components/LiveDonationPopup";
import ScrollToTop from "../components/ScrollToTop";


const AppRoutes = () => {
  return (
    <>
    <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/classes" element={<Classes />} />
        <Route path="/join" element={<JoinUs />} />
        <Route path="/admin" element={<Admin />} />

        {/* admin */}
        <Route path="/admin/login" element={<Login />} />

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute role="ADMIN">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/volunteer/dashboard"
          element={
            <ProtectedRoute role="VOLUNTEER">
              <VolunteerDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>

    </>
  );
};

export default AppRoutes;

